import { createAction } from 'redux-actions';

import {
  LOAD_CASE_LIST,
  LOAD_CASE_LIST_SUCCESS,
  LOAD_CASE_LIST_ERROR,
} from './type';

//Load case list
export const loadCaseListAction = createAction(LOAD_CASE_LIST);
export const loadCaseListSuccessAction = createAction(LOAD_CASE_LIST_SUCCESS);
export const loadCaseListErrorAction = createAction(LOAD_CASE_LIST_ERROR);
